module.exports = __webpack_public_path__ + "media/application/images/svgs/details-list-6aa4f2909f3dd49c1dc5a9f84a72dc13.svg";